<template>
  <mf-loading-dialog :loading="$apollo.loading">
    <div class="whatsapp-home">
      <v-row>
        <triggers-activity-chart />
      </v-row>
      <v-row>
        <triggers-queue-chart />
      </v-row>
    </div>
  </mf-loading-dialog>
</template>

<script>
export default {
  components: {
    TriggersActivityChart: () => import('@/modules/campanhas/whatsapp/views/components/TriggersActivityChart.vue'),
    TriggersQueueChart: () => import('@/modules/campanhas/whatsapp/views/components/TriggersQueueChart.vue'),
  },
}
</script>

<style lang="scss">
.table-card-title-whats {
  font-size: 18px;
  color: $cinza-d10;
  @extend .card-title;
}
</style>
